import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import sanitizeItemContextMetadata from 'analytics/snowplow/eventContexts/item/sanitizeItemContextMetadata'

function getMerchandiseCheckoutItem(state: App.State, item: App.Checkout.MerchandiseItem, isMultiCart?: boolean) {
  const offerId = item.advertId
  const merchandise = state.merchandise.merchandise[offerId] as App.MerchandiseOffer | undefined

  return comluxgroup.createItem_1_1_2({
    offerId: offerId,
    categoryId: 'shop',
    productId: 'merchandise',
    offerLeadPrice: merchandise?.variants[0].price,
    price: merchandise?.variants[0].price,
    currency: state.geo.currentCurrency,
    metadata: sanitizeItemContextMetadata({
      isMultiCart,
    }),
  })
}

export default getMerchandiseCheckoutItem
